"use strict";
import storage from "./storage.js";
import events from "./event.js";
/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace PersonalOfferStorageService
 */

const STORAGE_KEY = storage.metadata.PERSONAL_OFFER;
const STORAGE_KEY_V2 = storage.metadata.PERSONAL_OFFER_V2;

// ---------------------------------------------
//
//            Define public methods
//
// ---------------------------------------------
const publicMethods = {
    clearPersonalOffer: () => {
        publicMethods.setPersonalOffer(null);
    },
    getPersonalOffer: () => {
        const personalOffer = storage.getItem(STORAGE_KEY);
        let tmpOffer;
        if (personalOffer){
            tmpOffer = personalOffer;
        }
        return tmpOffer;
    },
    setPersonalOffer: (personalOffer) => {
        if (personalOffer == null || typeof (personalOffer) == 'undefined') {
            storage.removeItem(STORAGE_KEY);
        } else {
            storage.setItem(STORAGE_KEY, personalOffer);
        }
        events.setValue(events.shop.PERSONAL_OFFER_LOADED, [personalOffer]);
    },
    isPersonalOffer: () => {
        const personalOffer = publicMethods.getPersonalOffer();
        return personalOffer !== null && personalOffer !== undefined;
    },
    // v2
    getSessionId: () => {
        const data = storage.getItem(STORAGE_KEY_V2);
        return data
            ? data.sessionId
            : null
    },
    setSessionId: (sessionId) => {
        storage.setItem(STORAGE_KEY_V2, {
            sessionId
        })
    }
};

export default publicMethods;
